import { gql } from '@apollo/client';
export const userRoleQuery = gql `
  query GetUserRole($id: UUID!) {
    companyUser: companyUser2(id: $id) {
      id
      role
      canManageMember
    }
  }
`;
